import { deleteDismissedData } from "./dismiss";
import { deleteRedirectData } from "./redirect";
import { deleteBounceData } from "./bounce";
import { deleteRecoveryData } from "./recovery";
import { deleteAttributionExpiry } from "./attributionExpiry";
import { deleteSettingsEtag } from "./etag";

export function invalidateUserData() {
  deleteRecoveryData();
  deleteRedirectData();
  deleteBounceData();
  deleteAttributionExpiry();
  deleteSettingsEtag();
  deleteDismissedData();
}
